import React from 'react';
import './Clock.scss';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import * as moment from 'moment-timezone';

type Props = {
  timezone: string
};

type State = {
  time: string,
  date: string,
  day: string
};

class Clock extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      time: '',
      date: '',
      day: ''
    };
  }

  componentDidMount = () => {
    this.timerID = setInterval(() => this.update(), 1000);
  };

  componentWillUnmount = () => {
    clearInterval(this.timerID);
  };

  update = () => {
    const { timezone } = this.props;
    const datetime = moment().tz(timezone);

    this.setState({
      time: datetime.format('H:mm'),
      date: datetime.format('Do MMMM YYYY'),
      day: datetime.format('dddd')
    });
  };

  render() {
    const { time, date, day } = this.state;
    return (
      <div className="clock">
        <Typography
          variant="display3"
          classes={{
            root: classNames('time')
          }}
        >
          {time}
        </Typography>
        <Typography
          variant="display1"
          classes={{
            root: classNames('date')
          }}
        >
          {day}
        </Typography>
        <Typography
          variant="display1"
          classes={{
            root: classNames('date')
          }}
        >
          {date}
        </Typography>
      </div>
    );
  }
}

export default Clock;
